import React, { useEffect, useRef, useState } from 'react';

import { useMediaQuery } from 'react-responsive';

import { Helmet } from 'react-helmet';

import Box from '@/lib/components/Box';
import Text from '@/lib/components/Text';

import Constants from '@/lib/constants';
import Theme from '@/lib/styling/theme';

// eslint-disable-next-line import/no-webpack-loader-syntax
import ReactLicense from '!raw-loader!react/LICENSE';
// eslint-disable-next-line import/no-webpack-loader-syntax
import CracoLicense from '!raw-loader!@craco/craco/LICENSE';
// eslint-disable-next-line import/no-webpack-loader-syntax
import AlgoSdkLicense from '!raw-loader!algosdk/LICENSE';
// eslint-disable-next-line import/no-webpack-loader-syntax
import Base64License from '!raw-loader!base-64/LICENSE-MIT.txt';
// eslint-disable-next-line import/no-webpack-loader-syntax
import BigJsLicense from '!raw-loader!big.js/LICENCE.md';
// eslint-disable-next-line import/no-webpack-loader-syntax
import EthereumJsWalletLicense from '!raw-loader!ethereumjs-wallet/LICENSE';
// eslint-disable-next-line import/no-webpack-loader-syntax
import QrCodeReactLicense from '!raw-loader!qrcode.react/LICENSE';
// eslint-disable-next-line import/no-webpack-loader-syntax
import ReactBeforeUnloadLicense from '!raw-loader!react-beforeunload/LICENSE';
// eslint-disable-next-line import/no-webpack-loader-syntax
import ReactCopyToClipboardLicense from '!raw-loader!react-copy-to-clipboard/LICENSE';
// eslint-disable-next-line import/no-webpack-loader-syntax
import ReactHelmetLicense from '!raw-loader!react-helmet/LICENSE';
// eslint-disable-next-line import/no-webpack-loader-syntax
import ReactIconsLicense from '!raw-loader!react-icons/LICENSE';
// eslint-disable-next-line import/no-webpack-loader-syntax
import ReactModalLicense from '!raw-loader!react-modal/LICENSE';
// eslint-disable-next-line import/no-webpack-loader-syntax
import ReactResponsiveLicense from '!raw-loader!react-responsive/LICENSE';
// eslint-disable-next-line import/no-webpack-loader-syntax
import ReactRouterDomLicense from '!raw-loader!react-router-dom/LICENSE';
// eslint-disable-next-line import/no-webpack-loader-syntax
import ReactToPrintLicense from '!raw-loader!react-to-print/LICENSE';
// eslint-disable-next-line import/no-webpack-loader-syntax
import ToFormatLicense from '!raw-loader!toformat/LICENCE';
// eslint-disable-next-line import/no-webpack-loader-syntax
import Utf8License from '!raw-loader!utf8/LICENSE-MIT.txt';

import DarkStyles from './dark.module.css';

const CoinInfoLicense = `Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`;

const CoinKeyLicense = `Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`;

const ReactTickerLicense = `© https://github.com/AndreasFaust
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`;

const SecureRandomLicense = `Copyright 2013-2014, JP Richardson
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`;

function Attribution({projectName, projectLicense}) {
    return (
        <Box style={{marginTop: 24}}>
            <Text textStyle="body2">{ projectName }</Text>
            <Box className={DarkStyles.codeBox} style={{marginTop: 8, padding: 8}}>
                <pre>{projectLicense}</pre>
            </Box>
        </Box>
    );
}

export default function Credits() {
    const timeoutRef = useRef(null);

    const isMobile = useMediaQuery({
        query: '(max-width: 700px)'
    });

    function scrollDown() {
        window.scrollBy(0, 1);
        timeoutRef.current = setTimeout(() => scrollDown(), 25);
    }

    const [windowHeight, setWindowHeight] = useState(0);

    useEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
        window.scrollTo(0, 0);
        setWindowHeight(window.innerHeight);
        timeoutRef.current = setTimeout(() => {
            window.scrollTo(0, 0);
            scrollDown()
        }, 50);

        return () => {
            timeoutRef.current && clearTimeout(timeoutRef.current);
        }
    }, []);

    return (
        <Box style={{flex: 1, backgroundColor: 'black', color: 'white', paddingTop: windowHeight * 0.9, paddingBottom: windowHeight * 0.5, alignItems: 'center'}}>
            <Helmet>
                <title>{Constants.APP_NAME}: Credits</title>
            </Helmet>
            <Box className={DarkStyles.content}>
                <Text textStyle={isMobile ? "headline" : "chungus"} style={{ textAlign: 'center'}} bold><a href="/" style={{color: Theme.colorPrimary}}>🎄Cryptomas</a></Text>
                <Text textStyle="title" style={{marginBottom: windowHeight * 0.1, textAlign: 'center'}}>by <a href="https://twitter.com/iamtonypeng" style={{fontWeight: 'bold'}} target="_blank">Tony Peng</a></Text>
                <Box style={{marginBottom: windowHeight * 0.2, paddingLeft: 16, paddingRight: 16}}>
                    <Text textStyle="headline" style={{marginBottom: 16, textAlign: 'center'}}>Open Source Software We Used</Text>
                    <Box>
                        <Text textStyle="subhead">{Constants.APP_NAME} depends on many third-party open source projects, and we list attributions for them below. Thank you so much to the contributors to these projects and to the open source community! ❤️</Text>
                    </Box>
                    <Box className={DarkStyles.moralSupport} style={{marginTop: 16}}>
                        <Attribution projectName="craco" projectLicense={CracoLicense} />
                        <Attribution projectName="algosdk" projectLicense={AlgoSdkLicense} />
                        <Attribution projectName="base-64" projectLicense={Base64License} />
                        <Attribution projectName="big.js" projectLicense={BigJsLicense} />
                        <Attribution projectName="coininfo" projectLicense={CoinInfoLicense} />
                        <Attribution projectName="coinkey" projectLicense={CoinKeyLicense} />
                        <Attribution projectName="ethereumjs-wallet" projectLicense={EthereumJsWalletLicense} />
                        <Attribution projectName="qrcode.react" projectLicense={QrCodeReactLicense} />
                        <Attribution projectName="React" projectLicense={ReactLicense} />
                        <Attribution projectName="react-before-unload" projectLicense={ReactBeforeUnloadLicense} />
                        <Attribution projectName="react-copy-to-clipboard" projectLicense={ReactCopyToClipboardLicense} />
                        <Attribution projectName="react-helmet" projectLicense={ReactHelmetLicense} />
                        <Attribution projectName="react-icons" projectLicense={ReactIconsLicense} />
                        <Attribution projectName="react-modal" projectLicense={ReactModalLicense} />
                        <Attribution projectName="react-responsive" projectLicense={ReactResponsiveLicense} />
                        <Attribution projectName="react-router-dom" projectLicense={ReactRouterDomLicense} />
                        <Attribution projectName="react-ticker" projectLicense={ReactTickerLicense} />
                        <Attribution projectName="react-to-print" projectLicense={ReactToPrintLicense} />
                        <Attribution projectName="secure-random" projectLicense={SecureRandomLicense} />
                        <Attribution projectName="toformat" projectLicense={ToFormatLicense} />
                        <Attribution projectName="utf8" projectLicense={Utf8License} />
                    </Box>
                </Box>
            </Box>
            <Text>&copy; 2020. All rights reserved.</Text>
        </Box>
    );
}
